import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import LOCAL_STORAGE_KEYS from '@constants/localStorageKeys'

/**
 * Handles different platforms OAuth redirect callback.
 *
 * When a user is redirected to the platform (like GitHub or Netlify) for OAuth authentication (OAuth authorization page),
 * GitHub, for example, always sends them back to the configured callback URL (typically '/').
 * This redirection occurs whether the user is logging in for the first time or they
 * are repeatedly attempting to log in (e.g., more than 6 consecutive attempts).
 *
 * @param to - The target route object being navigated to.
 * @param next - The navigation guard callback to control the navigation.
 */

export const handlePlatformOAuthRedirect = (
  to: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const storedRoute = localStorage.getItem(
    LOCAL_STORAGE_KEYS.third_party_auth_route_to_redirect,
  )
  // Remove the stored route from localStorage to prevent future redirects.
  localStorage.removeItem(LOCAL_STORAGE_KEYS.third_party_auth_route_to_redirect)

  if (storedRoute && to.fullPath !== storedRoute) {
    const url = new URL(storedRoute, window.location.origin)
    const spaceIdQuery = url.searchParams.get('spaceId')
    const step = url.searchParams.get('step')

    if (!spaceIdQuery) {
      next({ path: url.pathname })
      return
    }

    next({
      path: url.pathname,
      query: {
        spaceId: spaceIdQuery,
        step: step ?? '0',
      },
    })
  }
}
